import { Col } from 'react-bootstrap';

import { useTextColor } from '@/resources/hooks/useTextColor';
import { useWebContext } from '@/resources/hooks/useWebContext';

export function Identify() {
  const { configs, setShowIdenfificationModal } = useWebContext();
  const textColor = useTextColor(configs.default_color);
  return (
    <li style={{ listStyle: 'none', padding: 0, margin: 0 }} className="w-100">
      <div className="d-flex align-items-start justify-content-between flex-column p-2">
        <Col xs={12} className="d-flex flex-column align-items-start">
          <span style={{ fontSize: '1.2rem' }} className="pb-2">
            <strong>Seja bem-vindo(a)!</strong>
          </span>
          <span className="text-muted" style={{ fontSize: '0.9rem' }}>
            Cadastre-se ou faça Login e garanta nossas orfetas!
          </span>
        </Col>
        <Col xs={12} className="flex flex-column align-items-center text-center">
          <div className="mt-2 d-flex justify-content-between align-items-center">
            <button
              className="btn col-5"
              style={{ backgroundColor: configs.default_color, color: textColor }}
              onClick={() => setShowIdenfificationModal(true)}
            >
              Login
            </button>
            <button
              className="btn btn-outline-secondary col-5"
              onClick={() => setShowIdenfificationModal(true)}
            >
              Cadastre-se
            </button>
          </div>
        </Col>
      </div>
    </li>
  );
}
